import BaseService from "@/app/core/base/BaseService";
import { toast } from "react-toastify";
import { HandleErrors } from "../../util/helpers/ErrorHelper";

export const CardsController = {
    BaseModel: {
        number: "",
        holderName: "",
        holderDocument: "",
        expMonth: 0,
        expYear: 0,
        cvv: 0,
        brand: "",
        label: "",
        billingAddress: {
            line1: "",
            line2: "",
            zipCode: "",
            city: "",
            state: "",
            country: ""
        },
        options: {
            verifyCard: true
        }
    },

    BaseResponse: {
        id: "string",
        createdAt: "2023-08-11T15:54:49.533Z",
        updatedAt: "2023-08-11T15:54:49.533Z",
        userId: "string",
        label: "string",
        brand: "string",
        holderName: "string",
        holderDocument: "string",
        lastFourDigits: "string",
        expMonth: 0,
        expYear: 2030
    },

    Insert: async function (data, response, error){
        await BaseService(
            {
              method: "POST",
              url: "cards/",
              data: data,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Delete: async function (id, response, error){
        await BaseService(
            {
              method: "DELETE",
              url: `cards/${id}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    Get: async function (id, response, error){
        await BaseService(
            {
              method: "GET",
              url: `cards/${id}`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },

    List: async function (response, error){
        await BaseService(
            {
              method: "GET",
              url: `cards/`,
            },
            (res) => response(res),
            (err) => error !== undefined ? error(err) : toast.error(HandleErrors(err))
        );
    },
}